import MuxAudio from '@mux-elements/mux-audio-react';
import React from 'react';
import ReactPlayer from 'react-player';
import { SectionModule } from '../../../../api/models/BibleStudyModule';
import { getMuxHlsPlayback } from '../../../../util/mux-utilities';
import { RhButton, RhButtonMode } from '../../../core/RhButton';
import { RhImage } from '../../../core/RhImage';
import { RhModal, RhModalProps } from '../../../core/RhModal';
import { H3, H4, H5 } from '../../../core/Styles';
import { ScriptureText } from './ScriptureText';
import MarkdownIt from 'markdown-it';

const md = new MarkdownIt();

interface ViewModuleModalProps extends Omit<RhModalProps, 'children'> {
  module: SectionModule;
}

export const ViewModuleModal = ({ module, ...rest }: ViewModuleModalProps) => {
  return (
    <RhModal {...rest}>
      <div className="space-y-6">
        {/* Header */}
        <div className="flex items-center space-x-4">
          <div className="rounded-lg w-14 h-14 bg-stone-200"></div>
          <div>
            <H5>{module.moduleType === 'qanda' ? 'Q&A' : module.moduleType}</H5>
            {(module.moduleType === 'document' || module.moduleType === 'image') && <H3>{module.name}</H3>}
            {(module.moduleType === 'video' ||
              module.moduleType === 'scripture' ||
              module.moduleType === 'qanda' ||
              module.moduleType === 'audio' ||
              module.moduleType === 'text') && <H3>{module.title}</H3>}
          </div>
        </div>
        {/* Body */}
        <div>
          {/* Video module */}
          {module.moduleType === 'video' && !!module.muxID && (
            <ReactPlayer url={getMuxHlsPlayback(module.muxID)} controls />
          )}
          {/* Image module */}
          {module.moduleType === 'image' && !!module.url && <RhImage src={module.url} mode="full" />}
          {/* Scripture module */}
          {module.moduleType === 'scripture' && !!module.scriptureIDList?.length && !!module.translationID && (
            <ScriptureText scriptureIds={module.scriptureIDList[0]} version={module.translationID} />
          )}
          {/* Q&A module */}
          {module.moduleType === 'qanda' && (
            <div className="space-y-6">
              {/* Questions */}
              <div className="space-y-4 overflow-y-auto max-h-[30vh]">
                {module.questionAndAnswers?.map((item, i) => (
                  <div key={i}>
                    <H4>Question {i + 1}</H4>
                    <div>{item.question}</div>
                    <div>
                      Ans. <strong>{item.answer}</strong>
                    </div>
                  </div>
                ))}
              </div>
              {/* Scriptures, if present */}
              {!!module.translationID && !!module.scriptureIDList?.length && (
                <>
                  <div className="border-b" />
                  {module.scriptureIDList.map(scriptureIds => (
                    <ScriptureText scriptureIds={scriptureIds} version={module.translationID!} />
                  ))}
                </>
              )}
            </div>
          )}
          {/* Audio module */}
          {module.moduleType === 'audio' && !!module.muxID && (
            <>
              <audio style={{ width: '100%' }} controls src={module.muxID} />
              {/*<MuxAudio style={{ width: '100%' }} playbackId={module.muxID} streamType="on-demand" controls />*/}
            </>
          )}
          {module.moduleType === 'text' && (
            <div className="max-h-[40vh] overflow-y-auto">
              {
                <div
                  // The styling is defined in App.css
                  className="mission-statement"
                  dangerouslySetInnerHTML={{ __html: md.render(module.content) }}
                />
              }
            </div>
          )}
        </div>
        {/* Footer */}
        <div className="flex justify-end">
          <RhButton mode={RhButtonMode.text} title="Close" onClick={rest.onRequestClose} />
        </div>
      </div>
    </RhModal>
  );
};
